import { Box } from "@mui/material";
import BreadCrumbs from "components/Breadcrumbs/Breadcrumbs";
import DrawerHeader from "components/DrawerHeader";
import DisplayEntity from "components/PageBuilder/DisplayEntity";
import IndexWithSearchBar from "components/PageBuilder/IndexWithSearchBar";
import TableMonitoring from "components/TableMonitoring";
import TableHeaderStatic from "components/TableMonitoring/Header/Static/TableHeaderStatic";
import { useFilterContext } from "context/FilterContext";
import { useFilter } from "hooks/useFilter";
import { CommonTexts, reportsTexts } from "locale/es";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { initializeReportsByPatient } from "redux/reducers/patientReportReducer";
import ReportsTableRows from "./ReportsTableRows";
import NoDataTableBody from "components/TableMonitoring/Body/NoDataTableBody";
import { Outlet } from "react-router-dom";
import TextSnippetIcon from "@mui/icons-material/TextSnippet";
import TableRowStatic from "components/TableMonitoring/Body/TableRowStatic";
import FilterTable from "components/TableMonitoring/Toolbar/Filter";

const tableHeaders = [
  { name: "ID", value: "id" },
  { name: "Nombre del Reporte", value: "name" },
  { name: "Estado", value: "status" },
];


const Reports = ({ isDashboard }) => {
  const { selectedFilter, searchTerm } = useFilterContext();

  const patientId = useSelector(({ patient }) => patient.id);
  const { data, loading, error } = useSelector(
    ({ reportsByPatient }) => reportsByPatient
  );
  const dispatch = useDispatch();

  const adaptedTableHeaders = tableHeaders.map((header) => header.name);
  const { filteredData } = useFilter(data, adaptedTableHeaders);

  useEffect(() => {
    if (patientId && data?.length === 0) {
      dispatch(initializeReportsByPatient(patientId));
    }
  }, [patientId, dispatch]);

  const containerStyles = patientId
    ? { width: 350, mt: 2, mb: -2 }
    : { p: 2, m: 2, mx: { md: 10, lg: 30 } };

  return (
    <Box component='main' sx={ !isDashboard ? { flex: 1, p: 3, mb: 20 } : { mb: 20, mt: -4 }}>
      {!isDashboard && (
        <>
          <DrawerHeader />
          <BreadCrumbs
            name={CommonTexts.REPORT}
            icon={<TextSnippetIcon sx={{ mr: 0.5 }} fontSize='inherit' />}
          />
          <Box sx={containerStyles}>
            <IndexWithSearchBar />
          </Box>
        </>
      )}
      <DisplayEntity entityId={patientId}>
        <FilterTable data={data} tableHeaders={tableHeaders} />
        <TableMonitoring
          patientId={patientId}
          tableHeader={
            <TableHeaderStatic
              tableHeaders={adaptedTableHeaders}
              entity={patientId}
              canCreate={false}
            />
          }
        >
          {(selectedFilter && !searchTerm ? data : filteredData).map(
            (report) => (
              <TableRowStatic
                key={report.id}
                entity={report}
                loaded={!loading}
                // actions={
                //   <>
                //     <EditMenuOption entity={note} />
                //     <DeleteMenuOption entityId={note.id} />
                //   </>
                // }
              >
                <ReportsTableRows report={report} />
              </TableRowStatic>
            )
          )}
        </TableMonitoring>
        {data?.length === 0 && (
          <NoDataTableBody
            entity={patientId}
            noDataMessage={reportsTexts.NO_DATA}
          />
        )}
        {data?.length > 0 && filteredData?.length === 0 && searchTerm && (
          <NoDataTableBody
            entity={patientId}
            noDataMessage={reportsTexts.NO_DATA_FILTERS}
          />
        )}
      </DisplayEntity>
      <Outlet />
    </Box>
  );
};

export default Reports;

